import { render, staticRenderFns } from "./EllipsisWithTooltip.vue?vue&type=template&id=6c1aebf8&scoped=true"
import script from "./EllipsisWithTooltip.vue?vue&type=script&lang=js"
export * from "./EllipsisWithTooltip.vue?vue&type=script&lang=js"
import style0 from "./EllipsisWithTooltip.vue?vue&type=style&index=0&id=6c1aebf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1aebf8",
  null
  
)

export default component.exports